// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1sXNr","productName":"Table_productName__37TIp"};